<template>
    <div class="header flex-group flex-between">
      <div class="header-left" style="z-index:10000">
       <img class="back" v-if="pathname!='Ucenter' && pathname!='Login' && pathname!='Otp' && pathname!='Land'" @click="_goBack" src="~@/assets/back.png" alt="">
      </div>
      <img class="logo" v-if="pathname!='game'" src="~@/assets/logo.png" alt="">
      <div class="header-right"></div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Header',
  props: ['pathname'],
  data(){
    return {

    }
  },
  computed: {
    ...mapState(['lang'])
  },
  methods: {
    _goBack(){
      this.$router.go(-1);
    },
    _goCenter(){
      this.$router.push('/Ucenter');
    }
  }
}
</script>

<style lang="scss" scoped>
    .header{
      padding: rem(40) rem(58);
      .header-left{
        width: rem(99);
        height: rem(99);
        .back{
          width: 100%;
          height: 100%;
        }
      }
      .logo{
        width: rem(240);
        height: rem(156);
      }
      .header-right{
        width: rem(99);
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue